/////////////////////////////////////////////////////////////////
// Listing type that offers BOTH renting and buying on one       //
// listing.                                                      //
//                                                               //
// Note: this does NOT define listing types — those live in       //
// Console. The two halves are found by TRANSACTION PROCESS       //
// rather than by id, so renaming a listing type in Console       //
// (e.g. daily-rental -> fashion-rental) does not silently        //
// remove the dual option.                                        //
/////////////////////////////////////////////////////////////////

/** Id given to the synthesized "both" listing type. */
export const DUAL_LISTING_TYPE = 'rent-or-sell';

/** The rent half is whichever Console type uses a booking process. */
export const RENT_PROCESS = 'default-booking';

/** The buy half is whichever Console type uses a purchase process. */
export const SELL_PROCESS = 'default-purchase';

/**
 * True when the given listing type offers both renting and buying.
 * @param {string} listingType listing type id
 */
export const isDualListingType = listingType => listingType === DUAL_LISTING_TYPE;
